module.exports = __webpack_public_path__ + "img/ford03.8210036a.png";